import React, { useState } from "react";
import * as dayjs from "dayjs";
import IntlMessages, { IntlGetText } from "util/IntlMessages";
import { useTableReadOnly } from "app/routes/psp/management/useImpactReadOnly";
import { Button } from "@material-ui/core";
import MUIDataTable from "mui-datatables";
import CardBox from "components/CardBox/index";
import MediaModal from "./mediaModal";

const TableAM = ({
  data,
  handleOpenCRU,
  handleOpenDel,
  setCurrentRowObj,
  currentImpact,
  readOnly,
  setCurrentObjEdit, 
  loadTable
}) => {
  const isReadOnly = useTableReadOnly(readOnly);
  const datatableConfig = {
    textLabels: {
      body: {
        noMatch: "No hay resultados para la búsqueda actual",
        toolTip: "Ordenar",
        columnHeaderTooltip: (column) => `Ordernar por ${column.label}`
      },
      pagination: {
        next: "Siguiente",
        previous: "Anterior",
        rowsPerPage: "Items por pagina:",
        displayRows: "de"
      },
      toolbar: {
        search: "Busqueda",
        downloadCsv: "Descargar CSV",
        print: "Imprimir",
        viewColumns: "Ver columnas",
        filterTable: "Filtro"
      },
      filter: {
        all: "Todos",
        title: "FILTRO",
        reset: "LIMPIAR"
      },
      viewColumns: {
        title: "Mostrar columnas",
        titleAria: "Mostrar/Ocultar columnas"
      },
      selectedRows: {
        text: "item(s) seleccionados",
        delete: "Borrar",
        deleteAria: "Borrar filas seleccionadas"
      }
    }
  };

  const [open, setOpen] = useState(false);
  const [edit, setEdit] = useState(false);
  const [currentRow, setCurrentRow] = useState({});

  const options = {
    filter: false,
    filterType: "dropdown",
    download: false,
    print: false,
    viewColumns: false,
    selectableRows: "none",
    search: false,
    textLabels: datatableConfig.textLabels,
    pagination: false
  };

  const handleClick = (tableMeta) => {
    handleOpenCRU();
    setCurrentRowObj(
      !tableMeta ? null : tableMeta.tableData[tableMeta.rowIndex]
    );
  };
  const handleClickDelete = (tableMeta) => {
    handleOpenDel();
    setCurrentRowObj(tableMeta.tableData[tableMeta.rowIndex]);
  };

  function getMaxId(data) {
    if (!data || data.length === 0) {
      return null;
    }

    return data.reduce((maxId, currentObj) => {
      return currentObj.id > maxId ? currentObj.id : maxId;
    }, data[0].id);
  }
  const maxId = getMaxId(data);

  const closeModal = () => {
    setOpen(false);
  };

  const openModal = (obj, edit) => {
    setEdit(edit);
    setCurrentRow(obj);
    setOpen(true);
  };

  let columns = [
    {
      name: "estimatedDeliveryDate",
      label: IntlGetText("deliveryTracing.estimatedDeliveryDate"),
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return value ? dayjs(value).format("YYYY/MM/DD") : "";
        }
      }
    },
    {
      name: "deliveryDate",
      label: IntlGetText("deliveryTracing.deliveryDate"),
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return value ? dayjs(value).format("YYYY/MM/DD") : "";
        }
      }
    },
    {
      name: "delivery",
      label: IntlGetText("deliveryTracing.delivery"),
      options: {
        filter: false,
        sort: false
      }
    },
    {
      name: "cityName",
      label: IntlGetText("core.city"),
      options: {
        filter: false,
        sort: true
      }
    },
    {
      name: "marketChainName",
      label: IntlGetText("deliveryTracing.opl"),
      options: {
        filter: false,
        sort: true
      }
    },
    {
      name: "comment",
      label: IntlGetText("core.comment"),
      options: {
        filter: false,
        sort: true
      }
    },
    {
      name: "recordText",
      label: IntlGetText("core.record"),
      options: {
        filter: false,
        sort: true
      }
    },
    {
      name: "actions",
      label: IntlGetText("core.actions"),
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          var rowObj = tableMeta.tableData[tableMeta.rowIndex];
          if (rowObj.id === maxId && !isReadOnly) {
            return (
              <div className="HContainer">
                <Button
                  onClick={() => {
                    setCurrentObjEdit(true);
                    handleClick(tableMeta);
                  }}
                  variant="contained"
                  className="jr-btn jr-btn-xs"
                >
                  <i className="zmdi zmdi-edit"></i>
                </Button>
                <Button
                  onClick={() => openModal(rowObj, false)}
                  variant="contained"
                  className="jr-btn jr-btn-xs"
                >
                  <i className="zmdi zmdi-file"></i>
                </Button>
              </div>
            );
          } else {
            return (
              <div className="HContainer">
                <Button
                  onClick={() => {
                    setCurrentObjEdit(false);
                    handleClick(tableMeta);
                  }}
                  variant="contained"
                  className="jr-btn jr-btn-xs"
                >
                  <i className="zmdi zmdi-eye"></i>
                </Button>
                <Button
                  onClick={() => openModal(rowObj, true)}
                  variant="contained"
                  className="jr-btn jr-btn-xs"
                >
                  <i className="zmdi zmdi-file"></i>
                </Button>
              </div>
            );
          }
        }
      }
    }
  ];

  return (
    <div className="row">
      <CardBox styleName="col-12" cardStyle="p-0 border-dialog-card">
        <MUIDataTable
          className="border-dialog-card"
          data={data}
          columns={columns}
          options={options}
        />
      </CardBox>
      {!isReadOnly && (
        <div className="col-lg-12 col-md-12 col-xs-12 mt-4 text-center">
          <Button
            onClick={() => {
              setCurrentObjEdit(true);
              handleClick(null);
            }}
            variant="contained"
            color="primary"
          >
            {<IntlMessages id="core.add" />}
          </Button>
        </div>
      )}

      <MediaModal
        open={open}
        loadTable={loadTable}
        handleRequestClose={closeModal}
        rowObj={currentRow}
        edit={edit}
      />
    </div>
  );
};

export default TableAM;
